/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { EscalatedIssueFragmentDoc } from './EscalatedIssueFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IEscalatedIssuesQueryVariables = Types.Exact<{
  userEscalated?: Types.Maybe<Types.Scalars['Boolean']>
  first?: Types.Maybe<Types.Scalars['Int']>
}>

export type IEscalatedIssuesQuery = { __typename?: 'Query' } & {
  paginatedShipmentIssues: { __typename?: 'ShipmentIssueConnection' } & Pick<
    Types.IShipmentIssueConnection,
    'totalCount'
  > & {
      nodes?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'ShipmentIssue' } & Pick<
              Types.IShipmentIssue,
              'id' | 'escalated' | 'notified' | 'shouldEscalate' | 'shouldNotify' | 'priority'
            > & {
                type: { __typename?: 'ShipmentIssueType' } & Pick<
                  Types.IShipmentIssueType,
                  'id' | 'name'
                > & {
                    category?: Types.Maybe<
                      { __typename?: 'ShipmentIssueCategory' } & Pick<
                        Types.IShipmentIssueCategory,
                        'id' | 'name'
                      >
                    >
                  }
                shipment: { __typename?: 'Shipment' } & Pick<
                  Types.IShipment,
                  'id' | 'shipperRateType'
                > & {
                    shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
                      Types.IShipperApplication,
                      'id' | 'name'
                    >
                    equipment: { __typename?: 'Equipment' } & Pick<
                      Types.IEquipment,
                      'id' | 'name' | 'parentKey'
                    >
                    characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
                      Types.IShipmentCharacteristics,
                      | 'hazmat'
                      | 'hot'
                      | 'mustGo'
                      | 'backhaulEligible'
                      | 'rolloverCount'
                      | 'sameDaySpot'
                      | 'bounceCount'
                    >
                  }
              }
          >
        >
      >
    }
}

export const EscalatedIssuesDocument = gql`
  query EscalatedIssues($userEscalated: Boolean, $first: Int) {
    paginatedShipmentIssues(userEscalated: $userEscalated, first: $first) {
      totalCount
      nodes {
        ...EscalatedIssue
      }
    }
  }
  ${EscalatedIssueFragmentDoc}
`

/**
 * __useEscalatedIssuesQuery__
 *
 * To run a query within a React component, call `useEscalatedIssuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEscalatedIssuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEscalatedIssuesQuery({
 *   variables: {
 *      userEscalated: // value for 'userEscalated'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEscalatedIssuesQuery(
  baseOptions?: Apollo.QueryHookOptions<IEscalatedIssuesQuery, IEscalatedIssuesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IEscalatedIssuesQuery, IEscalatedIssuesQueryVariables>(
    EscalatedIssuesDocument,
    options
  )
}
export function useEscalatedIssuesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IEscalatedIssuesQuery, IEscalatedIssuesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IEscalatedIssuesQuery, IEscalatedIssuesQueryVariables>(
    EscalatedIssuesDocument,
    options
  )
}
export type EscalatedIssuesQueryHookResult = ReturnType<typeof useEscalatedIssuesQuery>
export type EscalatedIssuesLazyQueryHookResult = ReturnType<typeof useEscalatedIssuesLazyQuery>
export type EscalatedIssuesQueryResult = Apollo.QueryResult<
  IEscalatedIssuesQuery,
  IEscalatedIssuesQueryVariables
>
